import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { WhyAutomate } from "@/components/WhyAutomate";
import { Services } from "@/components/Services";
import { HowItWorks } from "@/components/HowItWorks";
import { ExampleProcesses } from "@/components/ExampleProcesses";
import { TechStack } from "@/components/TechStack";
import { SavingsCalculator } from "@/components/SavingsCalculator";
import { WhyMe } from "@/components/WhyMe";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { translations } from "@/i18n/translations";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

const Landing = () => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem("le_lang") : null;
    return saved === "ro" ? "ro" : "en";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("le_lang", lang);
    } catch (_e) {
      /* ignore */
    }
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const goToContact = () => scrollToId("contact");

  return (
    <div className="relative min-h-screen bg-[#0B132B] text-white overflow-x-hidden">
      <Header lang={lang} setLang={setLang} t={t} onCtaClick={goToContact} />
      <main>
        <Hero t={t} onPrimary={goToContact} onSecondary={goToContact} />
        <About t={t} />
        <WhyAutomate t={t} />
        <Services t={t} onContactClick={goToContact} />
        <HowItWorks t={t} />
        <ExampleProcesses t={t} />
        <TechStack t={t} />
        <SavingsCalculator t={t} onCtaClick={goToContact} />
        <WhyMe t={t} />
        <FAQ t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
      <CookieBanner t={t} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
